import React from 'react';

export const progressDate = (value) => value ? `${new Date(value).toLocaleString('en-GB', {
  timeZone: 'Europe/Minsk', day: '2-digit', month: '2-digit', year: 'numeric',
  hour: '2-digit', minute: '2-digit', second: '2-digit'
})} Minsk (UTC+3)` : '—';

const AutomationScenarioProgress = ({ progress }) => {
  if (!progress) return <div className='automation-progress'>Loading progress…</div>;
  const { state, scan = {} } = progress;
  const labels = {
    queued: 'Waiting for worker', running: scan.phase === 'selecting' ? 'Finding candidates' :
      (scan.phase === 'rechecking' ? 'Rechecking previous matches' : 'Checking trigger'),
    completed: 'Last check completed', paused: 'Paused', listening: 'Waiting for events',
    error: 'Check failed', stalled: 'No recent progress', stopped: 'Check interrupted'
  };
  return <section className='automation-progress' aria-label='Scenario progress'>
    <div className={`automation-progress-state automation-progress-state--${state}`}>
      {state === 'paused' ? '—' : (labels[state] || 'Waiting for worker')}
    </div>
    {state === 'stalled' && <p>No update for over 2 minutes. Check the worker.</p>}
    {state === 'queued' && <p>The trigger check has not started yet.</p>}
    {progress.heartbeat_at && <p>Updated {progressDate(progress.heartbeat_at)}</p>}
    {progress.error_code && <p className='automation-progress-error'>Last error: {progress.error_code}</p>}
  </section>;
};

export default AutomationScenarioProgress;
